import React from "react";
import { Progress, Tooltip } from "antd";
import {
  CURRENT_STROKE,
  TEAL,
  MAX_PROFICIENCY,
  BAR_HEIGHT,
  MIN_LABEL_PCT,
} from "../../EmployeeSkillsBridgerV2.constants";
import {
  BarWrapperStyled,
  BarLabelStyled,
  PointerRowStyled,
  RequiredIndicatorStyled,
  RequiredCaretIconStyled,
  RequiredValueStyled,
  BAR_TRAIL_STYLE,
} from "./ProficiencyBar.styles";

const toPct = (v) => (v != null ? Math.round((v / MAX_PROFICIENCY) * 100) : 0);

const ProficiencyBar = React.memo(({ current, required, showRequired }) => {
  const currentPct  = toPct(current);
  const requiredPct = toPct(required);
  const showArrow   = showRequired && required != null;

  const showCurrentLabel = currentPct >= MIN_LABEL_PCT;

  const tooltipTitle = (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: showArrow ? 6 : 0 }}>
        <span style={{ width: 10, height: 10, borderRadius: "50%", background: CURRENT_STROKE, display: "inline-block", flexShrink: 0 }} />
        <span>Current Proficiency: <strong>{current ?? "--"}</strong></span>
      </div>
      {showArrow && (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ width: 10, height: 10, borderRadius: "50%", background: TEAL, display: "inline-block", flexShrink: 0 }} />
          <span>Required Proficiency: <strong>{required ?? "--"}</strong></span>
        </div>
      )}
    </div>
  );

  return (
    <Tooltip title={tooltipTitle} placement="top">
      <div>
        <BarWrapperStyled>
          <Progress
            percent={currentPct}
            strokeColor={CURRENT_STROKE}
            styles={{ trail: BAR_TRAIL_STYLE }}
            showInfo={false}
            strokeLinecap="round"
            size={["100%", BAR_HEIGHT]}
          />
          {showCurrentLabel && (
            <BarLabelStyled $left={`${currentPct}%`} $color="#ffffff" $zIndex={2}>
              {current ?? "--"}
            </BarLabelStyled>
          )}
        </BarWrapperStyled>
        {showArrow && (
          <PointerRowStyled>
            <RequiredIndicatorStyled $pct={requiredPct} vertical align="center" gap={1}>
              <RequiredCaretIconStyled />
              <RequiredValueStyled>{required}</RequiredValueStyled>
            </RequiredIndicatorStyled>
          </PointerRowStyled>
        )}
      </div>
    </Tooltip>
  );
});

export default ProficiencyBar;
